import React from "react";
import { useTranslation } from "react-i18next";
import "../classes/recommendations.css";

import { recommendedsweetsData } from "../data/recommendationsData";
import ItemCard from "./ItemCard";

const Recommendations = () => {
  const { t, i18n } = useTranslation();
  const isTelugu = i18n.resolvedLanguage === "te";
  return (
    <section id="recommendation" className="recommendation">
      <div className="title">
        <h1>{t("home.recommendedSweets")}</h1>
      </div>

      <div className="recommendationBox">
        {recommendedsweetsData.map((item) => {
          const { name, nameTe, desc, descTe, price, quantity, image } = item;
          return (
            <ItemCard
              key={name}
              name={isTelugu ? nameTe : name}
              desc={isTelugu ? descTe : desc}
              price={price}
              quantity={quantity}
              image={image}
              showBtn={true}
              btnTxt={t("item.viewAll")}
              path="/sweets"
            />
          );
        })}
      </div>
    </section>
  );
};

export default Recommendations;
